module.exports = __webpack_public_path__ + "img/moovietime-logo.52f7e885.svg";